import {createStore} from "vuex";
import affectation from "./modules/affectation";
import agent from "./modules/agent";
import auth from "./modules/auth";
import dashboard from "./modules/dashboard";
import division from "./modules/division";
import dossier from "./modules/dossier";
import institution from "./modules/institution";
import rapport from "./modules/rapport";
import ia from "./modules/ia";
import motif from "./modules/motif";
import parametre from "./modules/parametre";
import permission from "./modules/permission";
import profil from "./modules/profil";
import secteur from "./modules/secteur";
import service from "./modules/service";
import user from "./modules/user";
import institution_type from "./modules/institution_type";
import caracterisation from "./modules/caracterisation";
import widget from "./modules/widget";
import category from "./modules/category";
import complainer from "./modules/complainer";
import right from "./modules/right";
import notification from "./modules/notification";
import user_activite from "./modules/user_activite";
import chat from "./modules/chat";
import statistiques from "./modules/statistiques";
import focal from "./modules/focal";



const store = createStore({

    state(){
       
    },
    modules:{
        affectation,
        agent,
        auth,
        category,
        complainer,
        caracterisation,
        dashboard,
        division,
        dossier,
        ia,
        institution,
        institution_type,
        motif,
        notification,
        parametre,
        permission,
        profil,
        rapport,
        right,
        secteur,
        service,
        user,
        user_activite,
        widget,
        chat,
        statistiques,
        focal
       
    }
})

export default store